module.exports = __webpack_public_path__ + "img/banner_img.85642c9d.png";